// Google Analytics 4 — chargé UNIQUEMENT après consentement explicite (Consent Mode v2).
// Aucun script Google n'est requis tant que le visiteur n'a pas accepté.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = "weyb-consent";
const CONSENT_TTL = 180 * 24 * 60 * 60 * 1000; // 6 mois (recommandation CNIL)

let loaded = false;

function ensureQueue() {
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) {
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag("consent", "default", {
            ad_storage: "denied",
            analytics_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            wait_for_update: 500,
        });
    }
}

export function getConsentChoice() {
    try {
        const raw = localStorage.getItem(CONSENT_KEY);
        if (!raw) return null;
        const { choice, ts } = JSON.parse(raw);
        if (!ts || Date.now() - ts > CONSENT_TTL) return null;
        return choice;
    } catch {
        return null;
    }
}

function loadGoogleTag() {
    if (loaded || !GA_ID) return;
    ensureQueue();
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
    document.head.appendChild(script);
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false }); // SPA : pages vues envoyées manuellement
    loaded = true;
}

function updateConsent(granted) {
    ensureQueue();
    const v = granted ? "granted" : "denied";
    window.gtag("consent", "update", {
        analytics_storage: v,
        ad_storage: v,
        ad_user_data: v,
        ad_personalization: v,
    });
}

export function acceptAnalytics() {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ choice: "granted", ts: Date.now() }));
    updateConsent(true);
    loadGoogleTag();
    trackPageView();
}

export function refuseAnalytics() {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ choice: "denied", ts: Date.now() }));
    updateConsent(false); // aucun script Google chargé pour ce choix
}

export function resetAnalyticsConsent() {
    localStorage.removeItem(CONSENT_KEY);
    window.location.reload();
}

export function restoreAnalyticsConsent() {
    const choice = getConsentChoice();
    if (choice === "granted") {
        updateConsent(true);
        loadGoogleTag();
    }
    return choice;
}

export function trackPageView() {
    if (!loaded || !GA_ID) return;
    window.gtag("event", "page_view", {
        page_location: window.location.href,
        page_path: window.location.pathname + window.location.search,
        page_title: document.title,
    });
}

// Événements GA4 : clic Cal.com / Export360 / WhatsApp / email / téléphone, soumissions de formulaires.
// N'émet que si le visiteur a accepté la mesure d'audience.
export function trackEvent(name, params = {}) {
    if (!loaded || !GA_ID) return;
    window.gtag("event", name, params);
}
